export enum SortBy {
    TitleAsc = 1,
    TitleDesc = 2,
    StartDateAsc = 3,
    StartDateDesc = 4,
    MostRelevant = 5
}